import { createSlice } from "@reduxjs/toolkit";

const cycleSlice = createSlice({
  name: "cycle",
  initialState: { selectedCycle: {}, list: [], type: [] },
  reducers: {
    setSelectedCycle: (state, action) => {
      return { ...state, selectedCycle: action.payload };
    },
    addCycleList: (state, action) => {
      return { ...state, list: action.payload };
    },
    addCycleTypeList: (state, action) => {
      return { ...state, type: action.payload };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = cycleSlice;

// Extract and export each action creator by name
export const { setSelectedCycle, addCycleList, addCycleTypeList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
